import React from 'react';
import { useMessageContext } from 'stream-chat-react';
import '../styles/CustomAvatar.css';
import { isValidPhotoUrl } from "../utils/validationUtils";
import { getInitials } from "../utils/stringUtils";
const CustomAvatar = () => {
  const { message, isMyMessage } = useMessageContext();
  const user = message?.user;
  const name = user?.name || user?.id || '';
  const initials = getInitials(name || user?.id); 
  const alignmentClass = isMyMessage() ? 'avatarchat--left' : 'avatarchat--right';
    
  return (
    <div className={`avatarchat ${alignmentClass}`}>
          {user?.photo && isValidPhotoUrl(user.photo) ? (
        <img src={user.photo} alt={user.name || 'avatar'} />
      ) : (
        <div className="initials-circle-chat">{initials}</div>
      )}
    </div>
  );
};

export default CustomAvatar;
